import { render, staticRenderFns } from "./legend.component.vue?vue&type=template&id=4179f2bc&scoped=true"
import script from "./legend.component.vue?vue&type=script&lang=ts"
export * from "./legend.component.vue?vue&type=script&lang=ts"
import style0 from "./legend.component.vue?vue&type=style&index=0&id=4179f2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179f2bc",
  null
  
)

export default component.exports